import { BilberryPromoCodeStatus, CartItem, OctoOrder } from '@repo/types';
import {
    createEmptyPriceSummary,
    getPriceSummaryFromCartItems,
    getPriceSummaryFromOctoBookings,
    PriceSummary,
} from '@repo/widget-utils/price-helper';
import { useMemo } from 'react';
import useActiveOctoBookings from './useActiveOctoBookings';
import { useConfigurations } from '@repo/widget-utils/widgetsConfiguration';

export function usePriceSummary(
    itemsToShow: CartItem[],
    isLoadingOctoOrder: boolean,
    octoOrder?: OctoOrder,
    appliedPromoCode?: BilberryPromoCodeStatus | null,
): PriceSummary {
    const configurations = useConfigurations();
    const activeOctoBookings = useActiveOctoBookings(octoOrder);

    return useMemo(() => {
        if (configurations.octo) {
            if (!octoOrder || isLoadingOctoOrder) return createEmptyPriceSummary();

            return getPriceSummaryFromOctoBookings(activeOctoBookings);
        } else {
            return getPriceSummaryFromCartItems(itemsToShow, appliedPromoCode);
        }
    }, [
        configurations.octo,
        octoOrder,
        isLoadingOctoOrder,
        activeOctoBookings,
        itemsToShow,
        appliedPromoCode,
    ]);
}
